var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pcWrap"},[_c('div',{attrs:{"id":"lazadaH5"}},[_c('login-line'),_c('banner'),_c('register-box'),_c('register-step')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }